import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 group">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-file-list-3-line text-xl text-primary-500"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
                  Sugargoo<span className="text-primary-500">Sheet</span>
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Independent Sugargoo Spreadsheet resource platform. Helping shoppers discover, compare and understand Sugargoo spreadsheet resources since 2026.
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                Quick Links
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Home
                </Link>
                <Link to="/blog" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Guides & Articles
                </Link>
                <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Categories
                </a>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  FAQ
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                Popular Categories
              </h4>
              <div className="flex flex-col gap-2">
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Shoes
                </a>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Hoodies & Sweaters
                </a>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  T-Shirts
                </a>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  Jackets
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                Visit Main Platform
              </h4>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Sugargoo Spreadsheet
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </div>
              </a>
              <p className="text-xs text-foreground-500 mt-4 leading-relaxed">
                This is an independent educational platform. Not affiliated with or endorsed by Sugargoo.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-10 pt-6 border-t border-background-200/70">
            <p className="text-xs text-foreground-500">
              &copy; 2026 SugargooSheet.icu - Independent Sugargoo Spreadsheet Resource. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                Main Site
              </a>
              <Link to="/blog" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                Blog
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}